// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunks/" + chunkId + "." + {"src_main_tsx": "5f574f9a193b8cd7","zypline-editor_src_RichTextEditorField_tsx": "f048b1921ac97132",}[chunkId] + ".css"
}